import { useDispatch } from 'react-redux'
import _ from '@strings'
import Spacer from '@components/Ui/Spacer'
import Button from '@components/Ui/Button'
import ErrorBox from '@components/Ui/Error'
import { loadStep } from '@store/actions/app'
import { STEP_DATETIME } from '@names'
import styles from './Error.scss'

const Error = () => {
  const dispatch = useDispatch()
  return (
    <div className={styles.base}>
      <ErrorBox>
        {_('errors.booking')}
        <Spacer vertical scale="1" />
        <div style={{ textAlign: 'center' }}>
          <Button onClick={() => dispatch(loadStep(STEP_DATETIME))}>
            {_('errors.booking_button')}
          </Button>
        </div>
      </ErrorBox>
    </div>
  )
}

Error.defaultProps = {}
Error.propTypes = {}

export default Error
